export default __webpack_public_path__ + "static/media/icon-left-round-arrow.8dce7214.svg";